// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"975f97a5","211":"37e336a8","668":"00a41477","947":"c565386b"}[chunkId] + ".chunk.js";
};